import { createComment, getComments } from "@queries/comment.queries";
import { commentBlog, getCommentBlog } from "@queries/blogs.queries";
import { createReply, getReplies } from "@queries/replies.queries";
import { createBlogReply, getBlogReplies } from "@queries/blogreplies.queries";
// import swal from "sweetalert";
import { HTTP_STATUS_CODES } from "@utils/constants";

export const postComment = async ({
  data,
  type,
  addComment,
  accessToken,
  setErrorMsg,
  toggleBlockedServiceModal,
}) => {
  if (!data) return () => {};

  const { text, userTagList, feedID, communityID, pComID, linkMetaData } = data;
  let obj = null,
    res = null;

  if (!text) return () => {};

  switch (type) {
    case "comment":
      obj = {
        feedID,
        communityID,
        comment: text,
        FeedCommentUserTags: userTagList,
        ts: Date.now(),
        linkMetaData,
      };

      res = await createComment({
        data: obj,
        accessToken: accessToken,
      });

      break;

    case "blog":
      res = await commentBlog({
        blogID: feedID,
        comment: text,
        accessToken: accessToken,
        ts: Date.now(),
        linkMetaData,
      });

      break;

    case "comment-reply":
      obj = {
        feedID,
        parentCommentID: pComID,
        comment: text,
        FeedCommentUserTags: userTagList,
        ts: Date.now(),
        linkMetaData,
      };

      res = await createReply({
        data: obj,
        accessToken: accessToken,
      });

      break;

    case "blog-reply":
      // blog-comment-reply
      obj = {
        blogID: feedID,
        parentCommentID: pComID,
        comment: text,
        // FeedCommentUserTags: userTagList,
        ts: Date.now(),
        linkMetaData,
      };
      res = await createBlogReply({
        data: obj,
        accessToken: accessToken,
      });
      break;

    default:
      return () => {};
  }
  if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
    setErrorMsg(res.message);
    toggleBlockedServiceModal();
    return () => {};
  }
  //console.log("postComment", res);
  // console.log("postComment", res)
  // console.log("addComment", addComment);
  if (addComment && res.success) addComment(res.response);
};

export const getCommentData = ({ data, User, userRole }) => {
  let totalCommentData = null;
  // console.log("getCommentData", data.response);
  let tempdata = data.response;
  if (!tempdata) {
    tempdata = data;
  }
  totalCommentData = {
    ...tempdata,
    User: {
      name: User.name,
      dp: User.dp,
      gender: User.gender,
      uid: User.uid,
    },
    ts: Date.now(),
    likeNo: 0,
    isLiked: false,
    likeType: "8001",
  };

  if (userRole) {
    totalCommentData.CommunityMember = {
      role: userRole,
    };
  }
  // console.log("ye raha",totalCommentData);

  return totalCommentData;
};

export const fetchMoreComments = async ({
  feedID,
  type,
  comments,
  setComments,
  setHasMore,
  accessToken,
}) => {
  // console.log("hello inside");
  let ts = null,
    res = null;
  // console.log("fetchMoreComments", comments);

  if (comments?.length > 0) {
    ts = comments[comments?.length - 1]?.ts;
    // console.log("2-ts",ts);
  }

  // console.log("1")
  if (type === "blog") {
    res = await getCommentBlog({
      blogID: feedID,
      ts: ts,
      accessToken: accessToken,
    });
    // console.log("3",res)
  } else {
    // console.log("4")
    res = await getComments({
      feedID,
      ts: ts,
      accessToken: accessToken,
    });
    // console.log("5",res)
  }

  if (res?.data?.length > 0) {
    setComments((cur) => cur.concat(res.data));
    //console.log("res => ", res);
    // console.log("6",res);
  } else setHasMore(false);
};

export const fetchMoreReplies = async ({
  comID,
  type,
  replies,
  setReplies,
  setHasMore,
  accessToken,
}) => {
  const ts = replies[replies.length - 1].ts;
  let res = null;

  //console.log({ replies, ts });

  if (type === "blog") {
    res = await getBlogReplies({
      parentCommentID: comID,
      accessToken: accessToken,
      ts: ts,
    });
  } else {
    res = await getReplies({
      parentCommentID: comID,
      accessToken: accessToken,
      ts: ts,
    });
  }

  //console.log("fetchMoreReplies", res);

  if (res?.length > 0) setReplies((cur) => cur.concat(res));
  else setHasMore(false);
};
